var _style, _defs, _mask, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBatchesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 25",
    style: {
      enableBackground: "new 0 0 24 25"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#D9D9D9;filter:url(#Adobe_OpacityMaskFilter);}\r\n\t.st1{mask:url(#mask0_4634_263_00000116216038153603850730000001359465347568506027_);}\r\n\t.st2{fill:#15B79E;}\r\n")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 3,
    y: 3.1,
    width: 18,
    height: 18
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3.1,
    width: 18,
    height: 18,
    id: "mask0_4634_263_00000116216038153603850730000001359465347568506027_"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.1,
    className: "st0",
    width: 24,
    height: 24
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M12.6,21.1c-0.5,0-0.8-0.2-1.2-0.5C11.2,20.4,11,20,11,19.5v-6.8c0-0.5,0.2-0.8,0.5-1.2 c0.3-0.3,0.7-0.5,1.2-0.5h6.8c0.5,0,0.8,0.2,1.2,0.5c0.3,0.3,0.5,0.7,0.5,1.2v6.8c0,0.5-0.2,0.8-0.5,1.2c-0.3,0.3-0.7,0.5-1.2,0.5 H12.6z M12.6,20.1h6.8c0.2,0,0.3-0.1,0.4-0.2c0.1-0.1,0.2-0.3,0.2-0.4v-6.8c0-0.2-0.1-0.3-0.2-0.4c-0.1-0.1-0.3-0.2-0.4-0.2h-6.8 c-0.2,0-0.3,0.1-0.4,0.2c-0.1,0.1-0.2,0.3-0.2,0.4v6.8c0,0.2,0.1,0.3,0.2,0.4C12.3,20.1,12.5,20.1,12.6,20.1z M7,17.4V8.7 c0-0.5,0.2-0.8,0.5-1.2c0.3-0.3,0.7-0.5,1.2-0.5h8.6v1H8.6c-0.2,0-0.3,0.1-0.4,0.2C8.1,8.4,8,8.6,8,8.7v8.6H7z M3,13.4V4.7 c0-0.5,0.2-0.8,0.5-1.2c0.3-0.3,0.7-0.5,1.2-0.5h8.6v1H4.6c-0.2,0-0.3,0.1-0.4,0.2C4.1,4.4,4,4.6,4,4.7v8.6H3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatchesIcon);
export default __webpack_public_path__ + "static/media/batches-icon.bfd8ab463c1ae3ce043f99171054aa12.svg";
export { ForwardRef as ReactComponent };